import { render, staticRenderFns } from "./UnsavedChangesModal.vue?vue&type=template&id=15aa1f70&scoped=true"
import script from "./UnsavedChangesModal.vue?vue&type=script&lang=js"
export * from "./UnsavedChangesModal.vue?vue&type=script&lang=js"
import style0 from "./UnsavedChangesModal.vue?vue&type=style&index=0&id=15aa1f70&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15aa1f70",
  null
  
)

export default component.exports